(() => {
  const initialize = gallery => {
    if (gallery.dataset.materialLensReady) return;
    gallery.dataset.materialLensReady = 'true';
    const stickyGallery = gallery.closest('.wallify-pdp-optimized .product__column-sticky');
    if (!stickyGallery || !window.ResizeObserver) return;
    const resizeObserver = new ResizeObserver(() => {
      if (!stickyGallery.isConnected) { resizeObserver.disconnect(); return; }
      stickyGallery.style.setProperty('--wallify-gallery-height', stickyGallery.getBoundingClientRect().height + 'px');
    });
    resizeObserver.observe(stickyGallery);
  };
  const initializeWithin = root => {
    if (root.nodeType !== 1 && root.nodeType !== 9) return;
    if (root.matches?.('gallery-carousel')) initialize(root);
    root.querySelectorAll('gallery-carousel').forEach(initialize);
  };
  initializeWithin(document);
  const observer = new MutationObserver(records => {
    const added = new Set();
    records.forEach(record => record.addedNodes.forEach(node => {
      if (node.nodeType === 1) added.add(node);
    }));
    added.forEach(initializeWithin);
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
